import React from 'react';
import 'katex/dist/katex.min.css';
var Latex = require('react-latex');

/*
 * SafeLatex — drop-in replacement for react-latex's <Latex> that fixes bare escaped dollars.
 *
 * react-latex's splitter regex allows \$ INSIDE a $...$ math span but never checks whether the
 * OPENING $ is escaped. So v2 content written as "a fee of \$25 plus \$40" (standard LaTeX for
 * currency, used across NewLearnQuestions/SATQuestions3) makes the $ of "\$25" open a math span
 * that swallows the sentence up to the next $. The old bank avoided this by writing currency
 * math-wrapped: $\$40$. fixBareCurrency converts the bare form to the math-wrapped form at
 * render time — a no-op for strings without \$, so legacy content is untouched.
 */

// A math span: $$...$$, or $...$ whose opening $ is not escaped (escaped chars allowed inside).
// The "not escaped" check lives in the exec loop below rather than as a (?<!\\) lookbehind:
// regex lookbehind is a PARSE-time SyntaxError on iOS Safari < 16.4, and this file is in the
// eager bundle, so the lookbehind form white-screened the entire app on those devices.
const MATH_SPAN = /\$\$[\s\S]+?\$\$|\$[^$\\]*(?:\\.[^$\\]*)*\$/g;

export function fixBareCurrency(text) {
  if (typeof text !== 'string' || text.indexOf('\\$') === -1) return text;
  let out = '';
  let last = 0;
  MATH_SPAN.lastIndex = 0;
  let m;
  // Replacement via arrow fn so the returned "$\$$" is literal (no replace-pattern expansion).
  while ((m = MATH_SPAN.exec(text)) !== null) {
    // Single-$ span whose opening $ is escaped: not a real math span. Resume the
    // scan one char later, like the lookbehind engine did. ("$$" alone is the
    // empty single-$ span, not a $$...$$ block — that alternative needs content.)
    if ((m[0][1] !== '$' || m[0] === '$$') && m.index > 0 && text[m.index - 1] === '\\') {
      MATH_SPAN.lastIndex = m.index + 1;
      continue;
    }
    out += text.slice(last, m.index).replace(/\\\$/g, () => '$\\$$');
    out += m[0];
    last = m.index + m[0].length;
  }
  out += text.slice(last).replace(/\\\$/g, () => '$\\$$');
  return out;
}

export default function SafeLatex({ children, ...rest }) {
  return <Latex {...rest}>{typeof children === 'string' ? fixBareCurrency(children) : children}</Latex>;
}
